import { apiClient } from './client';

// Medication interfaces
export interface ActiveMedication {
  id: string;
  name: string;
  dosageMg: number;
  frequencyHours: number;
  durationDays: number;
  instructions?: string | null;
  prescribedAt: string;
  endDate: string;
  consultationId: string;
}

export interface MedicationsResponse {
  activeMedications: ActiveMedication[];
  completedMedications: ActiveMedication[];
}

// Reminder interfaces
export interface MedicationReminder {
  id: string;
  scheduledFor: string;
  takenAt: string | null;
  skipped: boolean;
  medication: {
    id: string;
    name: string;
    dosageMg: number;
    frequencyHours: number;
  };
  instructions?: string | null;
}

export interface RemindersResponse {
  reminders: MedicationReminder[];
}

// Statistics interface
export interface PatientStats {
  total: number;
  taken: number;
  skipped: number;
  pending: number;
  adherenceRate: number;
  currentStreak: number;
  longestStreak: number;
  points: number;
}

export const patientService = {
  // Get active and completed medications
  async getMedications(): Promise<MedicationsResponse> {
    const response = await apiClient.get('/patient/medications');
    return response.data;
  },

  // Get medication reminders
  async getReminders(params?: {
    status?: 'pending' | 'taken' | 'skipped' | 'all';
    from?: string;
    to?: string;
  }): Promise<RemindersResponse> {
    const response = await apiClient.get('/patient/reminders', { params });
    return response.data;
  },

  // Mark reminder as taken
  async markReminderAsTaken(reminderId: string): Promise<{ message: string; takenAt: string }> {
    const response = await apiClient.post(`/patient/reminders/${reminderId}/take`);
    return response.data;
  },

  // Mark reminder as skipped
  async markReminderAsSkipped(reminderId: string): Promise<{ message: string }> {
    const response = await apiClient.post(`/patient/reminders/${reminderId}/skip`);
    return response.data;
  },

  // Get patient statistics for gamification
  async getStats(): Promise<PatientStats> {
    const response = await apiClient.get('/patient/stats');
    return response.data;
  },
};
